const accountTypeId = Object.freeze({
  rothIra: 1,
  traditionalIra: 2,
  individual: 3,
});

export default accountTypeId;
